<template>
  <div class="search-box search-box--shadow bg-grey-accent pt-2 pb-1">
    <svg class="icon icon-search mb-2"><use xlink:href="#icon-search" /></svg>
    <input
      v-if="!isMobile"
      id="search-box"
      ref="input"
      type="text"
      placeholder="Search our extensive curated collection of images"
      class="global-nav__search-input text-base py-0"
      @keyup="debouncedSearch"
    />
    <input
      v-else
      id="search-box"
      ref="mobileInput"
      type="text"
      placeholder="Search images"
      class="global-nav__search-input text-base py-0"
      @keyup="debouncedSearch"
    />
  </div>
</template>

<script>
import { eventBus } from '../shared/event-bus';
import debounce from 'lodash.debounce';
import { isMobileOrTablet } from '../../helpers/layout';

export default {
  name: 'Search',
  props: {
    searchTerm: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isMobile: false,
    };
  },
  watch: {
    searchTerm(newVal, oldVal) {
      if (this.$refs['input'].value !== newVal) {
        this.$refs['input'].value = newVal;
      }

      if (this.isMobile && this.$refs['mobileInput'].value !== newVal) {
        this.$refs['mobileInput'].value = newVal;
      }
    },
  },
  mounted() {
    this.isMobile = isMobileOrTablet();
  },
  methods: {
    debouncedSearch: debounce(({ target: { value } }) => {
      eventBus.updateSearchTerm(value);
    }, 500),
  },
};
</script>
